import '../teacherTests.css';
import React, {useContext, useEffect, useState} from 'react';
import {Assessment, Assignment, List, Rule} from "@mui/icons-material";
import Tab from "../../../common/Tab";
import Tabs from "../../../common/Tabs";
import TestExamReports from "./TestExamReports";
import {BrandContext} from "../../../common/BrandContext";
import axios from "../../../common/axios";
import TeacherTests from "./TeacherTests";
import CircularLoader from "../../../common/CircularLoader";
import TeacherTestResults from "./TeacherTestResults";
import TeacherTestsAssignments from "./TeacherTestsAssignments";
import TestEdit from "./TestEdit";

const AssessmentTabs = () => {
    const brandConfig = useContext(BrandContext);
    const [testGroups,setTestGroups] = useState([]);
    const [isLoading, setLoading] = useState(true);

    useEffect(()=>{
        setLoading(true);
        axios.get('/web/ui/test/testGroups')
            .then(response => {
                if (response.data) {
                    setTestGroups(response.data);
                }
            }).finally(()=>{
                setLoading(false)
            });
    },[]);

    if(isLoading) {
        return <CircularLoader/>
    }

    return(
        <Tabs id={'teacherTests'} variant="standard" destroyOnHidden={true}>
            <Tab id="my-tests" key={0} hash="my-tests" children={<TeacherTests/>} tab={
                <>
                    <List className={'margin-r--m'} />
                    <span className={'margin-r--m tabText'}>My {brandConfig.testsName.toLowerCase()}</span>
                </>
            } value={0}/>
            {testGroups.map((testGroup, index) => (
                <Tab id={'test-group-' + testGroup.testGroupCode.toLowerCase()} hash={'test-group-' + testGroup.testGroupCode.toLowerCase()} children={<TeacherTests testGroupCode={testGroup.testGroupCode}/>} tab={
                    <>
                        <List className={'margin-r--m'} />
                        <span className={'margin-r--m tabText'}>{testGroup.testGroupName}</span>
                    </>
                } key={index + 1} value={index + 1}/>
            ))}
            <Tab id="test-assignments" hash="test-assignments" children={<TeacherTestsAssignments/>} tab={
                <>
                    <Assignment className={'margin-r--m'} />
                    <span className={'margin-r--m tabText'}>Assigned</span>
                </>
            } key={testGroups.length + 1} value={testGroups.length + 1} />
            <Tab id="test-results" hash="test-results" children={<TeacherTestResults/>} tab={
                <>
                    <Rule className={'margin-r--m'} />
                    <span className={'margin-r--m tabText'}>Student results</span>
                </>
            } key={testGroups.length + 3} value={testGroups.length + 3} />
            <Tab id="test-reports" hash="test-reports" children={<TestExamReports style={{overflowX:'none'}} />} tab={
                <>
                    <Assessment className={'margin-r--m'} />
                    <span className={'margin-r--m tabText'}>Reports</span>
                </>
            } key={testGroups.length + 4} value={testGroups.length + 4} />
            {/*{brandConfig.useReactTestEditor && <Tab id="test-editor" hash="test-editor" children={<TestEdit />} tab={*/}
            {/*    <>*/}
            {/*        <Assessment className={'margin-r--m'} />*/}
            {/*        <span className={'margin-r--m tabText'}>Test Editor</span>*/}
            {/*    </>*/}
            {/*} key={testGroups.length + 5} value={testGroups.length + 5} />}*/}
        </Tabs>
    )
}
export default AssessmentTabs;
